import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
    selector: 'app-plan-selection',
    templateUrl: './plan-selection.component.html',
    styleUrls: ['./plan-selection.component.sass']
})
export class PlanSelectionComponent {
    @Input() customerPlans: any[] = [];
    @Input() selectedPlan: any;
    @Input() canEdit: boolean = false; // Controla se os botões de edição devem ser exibidos
    @Output() planSelected = new EventEmitter<any>();
    @Output() removeContract = new EventEmitter<any>();

    constructor(private toastService: ToastService) { }

    // Verifica se o plano possui contrato assinado baseado no status
    isContractSigned(plan: any): boolean {
        // Normalizar o status para maiúsculas para evitar problemas de case-sensitivity
        const status = (plan.contractStatus || '').toUpperCase();
        const isSigned = plan.hasContract && status === 'SIGNED';

        return isSigned;
    }

    onPlanSelect(plan: any): void {
        // Se não for editável, não fazer nada ao clicar
        if (!this.canEdit) return;

        // Usar o método de verificação para determinar se o contrato está assinado
        if (this.isContractSigned(plan)) {
            this.toastService.showWarn('Este plano já possui um contrato assinado e não pode ser selecionado');
            return;
        }

        // Verificação para planos sem contrato ou com contrato não assinado que pode ser removido
        if (!plan.hasContract || (plan.hasContract && plan.canRemoveContract)) {
            this.planSelected.emit(plan);
        }
        console.log('plano selecionado', plan);
    }

    /**
     * Retorna o texto para cada status de contrato
     */
    getContractStatusText(status: string): string {
        if (!status) return 'Sem contrato';

        // Normalizar o status para maiúsculas para evitar problemas de case-sensitivity
        const normalizedStatus = status.toUpperCase();

        switch (normalizedStatus) {
            case 'WAITING_FOR_SIGNATORIES':
                return 'Aguardando signatários';
            case 'WAITING_FOR_SIGNATURES':
                return 'Aguardando assinaturas';
            case 'PROCESSING':
                return 'Processando';
            case 'SIGNED':
                return 'Assinado';
            case 'CANCELED':
                return 'Cancelado';
            default:
                return `Status: ${status}`;
        }
    }
} 